<h1 mat-dialog-title i18n>Add Note</h1>
<div>
  <p i18n>To add a new note, complete the form below then click Submit.</p>
</div>
<form #noteForm="ngForm" (ngSubmit)="saveNote(noteForm)">
  <div class="form-group row">
    <label for="note_Text" class="col-sm-3 col-form-label" i18n>Description</label>
    <div class="col-sm-9">
      <textarea #quoteNote name="note_Text" id="note_Text"
                required=""
                [(ngModel)]="data.note.note_Text" #note_Text="ngModel"
                class="form-control" rows="3"></textarea>
      <div [hidden]="!noteForm.submitted || note_Text.valid"
           class="alert alert-danger" i18n>Enter note text</div>
    </div>
  </div>
  <div [hidden]="!noteForm.submitted || noteForm.valid"
       class="alert alert-danger" i18n>Validation issues encountered</div>
  <div class="mat-dialog-actions float-right">
    <div *ngIf="!isRequesting">
      <button type="submit" class="btn btn-bidit-submit mr-1" i18n>Submit</button>
      <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
    </div>
    <app-spinner [isRunning]="isRequesting"></app-spinner>
  </div>
</form>

